<template>
  <div class="container">
    <div class="top">
      <div class="btn-add" @click="showAddInput(1)">新建任务</div>
      <div class="flex-1"></div>
      <el-popover
          placement="bottom"
          popper-class="pm-top-more"
          trigger="click">
        <div slot="reference" class="more flex">
          <i class="el-icon-more fz-14"></i>
        </div>
        <div class="item-list">
          <div class="item" @click="delAll">
            <img src="../../../assets/images/trash.png" class="icon">
            清空全部任务
          </div>
        </div>
      </el-popover>
    </div>
    <div class="task-con">
      <div class="task-title">
        <div class="span"></div>
        <div class="name">名称</div>
        <div class="date">
          <div class="span start-date">起始日期</div>
          <div class="span">截止日期</div>
        </div>
      </div>
      <div class="task-list">
        <plan-master-add v-if="showAdd == 1" ref="refAdd" @save="save"></plan-master-add>
        <draggable
            v-model="list"
            :animation="300"
            group="task"
            :sort='true'
            handle=".icon-drag">
          <transition-group>
            <plan-master-item v-for="(item,index) in list" :item="item" :uuid="uuid" :showDone="showDone" :index="index"
                              :key="item.id"
                              @save="save" @freshList="getTasks" @dragStart="dragStart">
            </plan-master-item>
          </transition-group>
        </draggable>
        <plan-master-add v-if="showAdd == 2" ref="refAdd" @save="save" :pid="0" @freshList="getTasks"></plan-master-add>
        <div class="add-task flex pointer" @click="showAddInput(2)">
          <i class="el-icon-plus m-r-4"></i>
          新建任务
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import planMasterItem from './plan-master-item'
import planMasterAdd from './plan-master-add'
import {addOne, getList, taskDrag, delAll} from '@/api/planMaster'


export default {
  components: {
    draggable,
    planMasterItem,
    planMasterAdd
  },
  props: ['source'],
  data() {
    return {
      //source: 1, //来源： 1，saas; 2, web
      showDone: true, //是否显示已完成
      showAdd: 0, //是否显示添加任务
      list: [],
      isFirst: 0,
      dragId: '',
      proList: [],
      uuid: '',
    }
  },
  watch: {
    list: {
      handler(newVal, oldVal) {
        this.handleDrag()
      },
      deep: true,
    },
  },
  created() {
    if (this.source == 1) {
      this.getTasks()
    }
  },
  methods: {
    //setUuid
    setUuid(uuid) {
      console.log('set uuid=' + uuid)
      this.uuid = uuid
    },
    //获取任务列表
    getTasks() {
      getList({source: this.source}, this.uuid).then(res => {
        if (res.data) {
          this.list = res.data
        }
      })
    },
    //show 新建任务
    showAddInput(type) {
      console.log('show add ---')
      this.showAdd = type
      if (type == 1) {
        this.isFirst = 1
      } else {
        this.isFirst = 0
      }
      this.$nextTick(() => {
        this.$refs.refAdd.focus()
      })
    },
    //get 项目列表
    getProList() {

    },
    //清空全部任务
    delAll() {
      this.$confirm('此操作将删除全部任务, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delAll({}, this.uuid).then(res => {
          this.list = []
        })
      }).catch(() => {
      })

    },
    //保存创建任务
    save(name, pid = 0) {
      console.log('save name=' + name)
      console.log('save uuid=' + this.uuid)

      if (name == '') {
        this.showAdd = 0
        return false
      }
      addOne({name: name, pid: pid, is_first: this.isFirst}, this.uuid).then(res => {
        this.getTasks()
        this.showAdd = 0
      })
    },
    //当前拖拽的item id
    dragStart(id) {
      this.dragId = id
      this.isDrag = true
    },
    //do drag
    handleDrag() {
      if (this.dragId == "" || this.isDrag == false) {
        return false
      }
      let tid = this.dragId
      this.doHandleDrag(tid, this.list)
    },
    doHandleDrag(tid, child) {
      if (child.length == 0) {
        return false
      }
      //查找当前拖拽的tid 所在的列表
      let isIn = '';
      let ids = []
      child.forEach(item => {
        ids.push(item.id)
        if (item.id == tid) {
          isIn = 1
        }
      })
      if (isIn == 1) {
        taskDrag({
          id: this.dragId,
          ids: ids,
        }, this.uuid).then((res) => {
          this.isDrag = false
          this.list = res.data.list
        })
      } else {
        //循环遍历
        for (let i = 0; i < child.length; i++) {
          this.doHandleDrag(tid, child[i].child)
        }
      }
    },
  },
  computed: {}
}
</script>
<style lang="less">
.pm-popper-task-more {
  padding: 0;

  .btn-item {
    display: flex;
    flex-flow: row;
    height: 32px;
    align-items: center;
    cursor: pointer;

    &:hover {
      background: #F4F6FA;
    }

    .icon {
      width: 20px;
      height: 20px;
      margin-left: 16px;
      margin-right: 12px;
    }

    .label-ai {
      color: #704FF9;
    }
  }

}

.pm-top-more {
  padding: 10px 0;
  border-radius: 10px;

  .item-list {
    .item {
      width: 180px;
      height: 32px;
      display: flex;
      align-items: center;
      font-size: 13px;
      color: #10141B;
      cursor: pointer;

      &:hover {
        background: #F8F9FA;
      }

      img {
        width: 20px;
        height: 20px;
        margin: 0 10px 0 16px;
      }

      .icon {
        margin: 0 10px 0 16px;
        font-size: 18px;
      }
    }
  }
}

.pm-import-task {
  width: 300px;
  padding: 0 0 8px 0;

  .title {
    height: 36px;
    font-size: 11px;
    display: flex;
    align-items: center;
    border-bottom: 0.5px solid #E2E4E9;
    padding: 0 0 0 16px;
  }

  .empty-label {
    color: #ADB1BA;
  }

  .pro-item {
    height: 44px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    cursor: pointer;

    &:hover {
      background: #F8F9FA;
    }

    .icon {
      width: 20px;
      height: 20px;
      border-radius: 4px;
    }

    .name {
      width: 300px;
      font-size: 13px;
      color: #10141B;
      margin: 0 0 0 10px;
    }
  }

}
</style>
<style lang="less" scoped>
.container {


  max-width: 792px;
  min-width: 375px;
  margin: 0 auto;

  color: #10141B;

  .flex {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .top {
    display: flex;

    .btn-add {
      width: 88px;
      height: 34px;
      border: 1px solid var(--unnamed, #D0D1D6);
      border-radius: 10px;
      font-size: 13px;
      font-weight: 550;
      line-height: 34px;
      text-align: center;
      cursor: pointer;
      box-shadow: 0px 2px 12px 0px rgba(68, 73, 77, 0.13);
    }

    .more {
      width: 34px;
      height: 34px;
      border: 1px solid var(--unnamed, #D0D1D6);
      border-radius: 10px;
      font-size: 16px;
      cursor: pointer;
      box-shadow: 0px 2px 12px 0px rgba(68, 73, 77, 0.13);
    }

    .switcher {
      font-size: 13px;
      margin: 0 44px 0 0;
    }
  }

  .task-con {
    margin: 40px 0 0 0;
    padding-bottom: 20px;

    .task-title {
      width: 100%;
      height: 33px;
      display: flex;
      align-items: center;
      color: #787D86;
      font-size: 12px;
      border-bottom: 0.5px solid var(--normal, #F0F0F0);

      .span {
        width: 72px;
      }

      .name {
        //width: 650px;
        flex: 1;
      }

      .date {
        width: 300px;
        padding: 0 0 0 12px;
        box-sizing: border-box;
        display: flex;

        .start-date {
          margin: 0 48px 0 4px;
        }
      }
    }

    .task-list {

      .add-task {
        color: #787D86;
        height: 50px;
        justify-content: normal;
        padding: 0 0 0 50px;
        font-size: 14px;

        &:hover {
          background: var(--bglight, #F6F7FB);
        }
      }


    }
  }
}
</style>